import * as Sentry from '@sentry/react';

/**
 * Short-hand version to avoid code looking bloated.
 */
export function breadcrumb(message: string) {
  Sentry.addBreadcrumb({
    category: 'widget',
    message,
  });
}
